import React from 'react'
import { useNavigate } from 'react-router'

import ActionButton from '@/components/misc/ActionButton'
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { useAppState } from '@/hooks/useAppState'
import { useClientMetadata } from '@/hooks/useClientMetadata'
import { useCreateStateMutation } from '@/hooks/useCreateStateMutation'
import useDialog from '@/hooks/useDialog'
import { STATE_KEY, STATE_TYPE } from '@/lib/constants'
import { ROUTES } from '@/lib/routes'

const ReviewPartnerModal: React.FC = () => {
  const dialog = useDialog(true)
  const appState = useAppState()
  const createUserStateMutation = useCreateStateMutation()
  const navigate = useNavigate()

  const clientMetadata = useClientMetadata()

  if (
    appState.hasClientReviewedPartners ||
    clientMetadata?.sponsorCompany?.hasPanel !== true ||
    !clientMetadata.hasCompleteCompassReport
  ) {
    return null
  }

  function hideModal() {
    dialog.hideDialog()

    if (!appState.hasClientReviewedPartners) {
      createUserStateMutation.mutate({
        stateKey: STATE_KEY.hasClientReviewedPartners,
        stateValue: true,
        stateType: STATE_TYPE.user,
      })
    }
  }

  return (
    <Dialog open={dialog.isShowingDialog} onHide={dialog.hideDialog}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>See our partners</DialogTitle>
        </DialogHeader>

        <DialogBody>
          <p className="mb-0">
            Based on your snapshot, we recommend reviewing our selected
            partners. You can see a list of different professions via the{' '}
            <b>Our Partners</b> tab.
          </p>
        </DialogBody>

        <DialogFooter>
          <ActionButton
            variant="primary"
            className="float-left"
            size="lg"
            isProcessing={createUserStateMutation.isPending}
            onClick={() => {
              hideModal()
              navigate(ROUTES.compassPartners())
            }}
          >
            See our partners
          </ActionButton>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default ReviewPartnerModal
